module.exports = __webpack_public_path__ + "img/inspirational-motivator.9e0033ff.png";